module.exports = __webpack_public_path__ + "assets/img/title-e3ca0715.png";